import styled from 'styled-components';

const ItemName = styled.span`
  font-weight: 500;
`;

ItemName.displayName = 'ItemName';

export default ItemName;
